<template>

<div class="decision">

	<com-headmain :simple="true" />

	<div class="decision-content">

		<div class="decision-title">{{ section.patient.title || section.text.title }}<div class="subsection-close" v-on:click="$emit('back')"></div></div>

		<div class="decision-intro" v-if="section.intro" v-html="section.intro"></div>

		<div class="decision-scale" v-if="section.side_effects">

			<div class="decision-scale-label">{{ section.side_effects.label || 'Medicine side-effects' }}</div>

			<div class="decision-scale-text" v-if="section.side_effects.text" v-html="section.side_effects.text"></div>

			<div class="decision-scale-bar">
				<input type="range" min="0" max="10" v-model.number="sideEffects" class="decision-slider" />
				<div class="decision-scale-labels">
					<span>Not concerned</span>
					<span>Very concerned</span>
				</div>
			</div>

		</div>

		<div class="decision-scale" v-if="section.practical">

			<div class="decision-scale-label">{{ section.practical.label || 'Practical issues' }}</div>

			<div class="decision-scale-text" v-if="section.practical.text" v-html="section.practical.text"></div>

			<div class="decision-scale-bar">
				<input type="range" min="0" max="10" v-model.number="practical" class="decision-slider" />
				<div class="decision-scale-labels">
					<span>Not concerned</span>
					<span>Very concerned</span>
				</div>
			</div>

		</div>

		<com-check :text="section.text.title" v-on:click="$emit('next')" />

	</div>

</div>

</template>

<script>

import comHeadMain from './../../common/Head'
import comCheck from './common/Check'

export default {

	props: ['section'],

	components: {
		'com-headmain': comHeadMain,
		'com-check': comCheck
	},

	data: function() {

		return {
			sideEffects: 5,
			practical: 5
		}

	}

}

</script>

<style scoped>

.decision {
	position: absolute;
	left: 300px;
	right: 0px;
	top: 0px;
	height: 100%;
	z-index: 1;
	overflow-y: auto;
}

.is-tablet .decision { left: 64px; }
.is-mobile .decision { left: 0px; }

.decision-content {
	width: 100%;
	max-width: 800px;
	padding: 90px;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

.is-mobile .decision-content { padding: 80px 15px 85px 15px; }

.decision-title {
	font-weight: 100;
	font-size: 36px;
	line-height: 36px;
	letter-spacing: 3px;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 48px;
}

.decision-title:after { content: ' '; position: absolute; bottom: -16px; left: 0px; height: 4px; background-color: var(--aid-color); width: 150px; }

.is-mobile .decision-title { font-size: 18px; line-height: 18px; margin-bottom: 32px; }

.decision-intro { font-size: 18px; color: #343434; line-height: 28px; margin-bottom: 32px; }
.is-mobile .decision-intro { font-size: 14px; line-height: 22px; }

.decision-scale {
	margin-bottom: 40px;
	padding-bottom: 40px;
	border-bottom: 1px solid #e0e0e0;
}

.decision-scale:last-of-type { border-bottom: none; }

.decision-scale-label {
	font-size: 20px;
	font-weight: 600;
	color: #343434;
	margin-bottom: 8px;
}

.is-mobile .decision-scale-label { font-size: 16px; }

.decision-scale-text {
	font-size: 16px;
	color: #666;
	line-height: 24px;
	margin-bottom: 24px;
}

.decision-scale-bar { padding: 0 8px; }

.decision-slider {
	width: 100%;
	height: 8px;
	border-radius: 4px;
	background: linear-gradient(to right, var(--aid-color), #ee7173);
	outline: none;
	-webkit-appearance: none;
	appearance: none;
}

.decision-slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: #343434;
	cursor: pointer;
	border: 3px solid #fff;
	box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}

.decision-slider::-moz-range-thumb {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: #343434;
	cursor: pointer;
	border: 3px solid #fff;
	box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}

.decision-scale-labels {
	display: flex;
	justify-content: space-between;
	margin-top: 8px;
	font-size: 13px;
	color: #888;
	font-weight: 600;
}

</style>
